<template>
  <div class="pixel-picks">
    <CardWrapper class="pixel-picks__box pixel-picks__info">
      <div class="pixel-picks__info__title">
        Tell us which cosmetic items you want&nbsp;back in the Cash Shop coupon rotation! Click
        <span class="pixel-picks__info__link" @click="() => openDialog('details')">here</span>
        for more info.
      </div>

      <div class="pixel-picks__info__lvl">*Must be Lv. {{ minLevel }} or above to participate</div>

      <div class="pixel-picks__info__voting-period">
        <template v-if="!eventEnded">
          <div class="pixel-picks__info__voting-period__title">
            <i-local-star-bold class="star" />VOTING PERIOD<i-local-star-bold class="star" />
          </div>
          <div v-if="event.startTime && event.endTime" class="pixel-picks__info__voting-period__dates">
            {{ event.startTime }} - {{ event.endTime }}
          </div>
        </template>

        <template v-else>
          <div class="pixel-picks__info__voting-period__title">
            <i-local-star-bold class="star" />VOTING PERIOD ENDED<i-local-star-bold class="star" />
          </div>
          <div v-if="event.startTime && event.endTime" class="pixel-picks__info__voting-period__dates">
            Check back soon for the next round of Pixel Picks!
          </div>
        </template>
      </div>
    </CardWrapper>

    <CardWrapper
      v-if="!eventEnded || (eventEnded && userStore.isLoggedIn)"
      class="pixel-picks__box pixel-picks__box--categories"
    >
      <StyledTitle class="title">YOUR PICKS</StyledTitle>

      <Loading v-if="loadingEvent" show />

      <div v-else-if="categories" class="pixel-picks__categories">
        <div
          v-for="(category, index) in categories"
          :key="category.id"
          v-observable="{ callback: (visible: any, entry: any) => visible ? addElToStack(entry.target, index) : null, intersection: { threshold: 0.3 }, throttle: 250 }"
          class="pixel-picks__categories__category-wrapper"
          :style="{ visibility: 'hidden' }"
        >
          <div
            class="pixel-picks__categories__category"
            :class="{
              [`pixel-picks__bg-${category.color}`]: !category.userVotedItem && category.color,
              'pixel-picks__categories__category--voted': category.userVotedItem,
              'pixel-picks-winner': eventEnded && category.userVotedItem && category.userVotedItem.winner,
            }"
            :style="{
              backgroundImage: category.userVotedItem ? `url(${category.userVotedItem.image})` : '',
            }"
            @click="setSelectedCategory(index)"
          >
            <template v-if="!category.userVotedItem">
              <div
                class="pixel-picks__categories__category__name"
                :class="`pixel-picks__categories__category__name--w${category.name.split(' ').length}`"
              >
                Your {{ category.name }} Pick
              </div>
              <div v-if="!eventEnded" class="pixel-picks__button pixel-picks__button--border">VOTE HERE</div>
            </template>

            <div v-else-if="category.userVotedItem.voteData" class="pixel-picks__categories__category__item-percentage">
              {{ formatPercentage(category.userVotedItem.voteData?.percentage) }}
            </div>
          </div>

          <div
            v-if="category.userVotedItem && category.userVotedItem.name"
            class="pixel-picks__categories__category__item-name"
          >
            {{ category.userVotedItem.name }}
          </div>
        </div>
      </div>
    </CardWrapper>

    <div
      v-if="showStickyMenu && categories.length > 0"
      class="pixel-picks__menu"
      :style="{
        ...(mobile
          ? {
              // ...menuStyles,
            }
          : {
              top: `${headerHeight + 20}px`,
              marginRight: `-${menuMarginRight - 5}px`,
            }),
      }"
    >
      <div v-if="mobile" class="pixel-picks__menu__top" @click="mobileMenuExpanded = !mobileMenuExpanded">
        <div class="pixel-picks__menu__top__title">CATEGORY</div>
        <div
          class="pixel-picks__menu__top__action"
          :class="{
            'pixel-picks__menu__top__action--expanded': !mobileMenuExpanded,
          }"
        />
      </div>
      <div
        class="styled-scrollbar"
        :style="{
          maxHeight: mobile ? '' : `calc(100vh - ${mobile ? headerHeight + 5 : headerHeight + 40}px)`,
        }"
      >
        <v-expand-transition>
          <div v-if="(mobileMenuExpanded && mobile) || !mobile">
            <div
              v-for="(category, index) in categories"
              :key="index"
              class="pixel-picks__menu__item"
              :class="[
                category.color ? `pixel-picks__bg-${category.color}` : '',
                {
                  active: category.name === selectedCategory.name,
                  'pixel-picks__menu__item--voted': category.userVotedItem,
                },
              ]"
              @click="setSelectedCategory(index)"
            >
              <div class="pixel-picks__menu__item__title">
                {{ category.name }}
              </div>
            </div>
          </div>
        </v-expand-transition>
      </div>
    </div>

    <CardWrapper ref="itemsCardEl" class="pixel-picks__box pixel-picks__box--items">
      <Loading v-if="loadingEvent" show />

      <template v-else-if="selectedCategory">
        <!-- <div v-if="mobile" ref="itemsTitleMobile" class="styled-title-m">
          <div class="star left"></div>
          <span v-for="(item, index) in selectedCategory.name.split(' ')" :key="index" ref="itemsTitleLastWord">
            {{ item }}
          </span>
          <div class="star right"></div>
        </div> -->

        <!-- <StyledTitle v-else class="title">
          {{ selectedCategory.name }}
        </StyledTitle> -->

        <StyledTitle
          ref="itemsTitleMobile"
          class="title"
          :style="{
            '--title-line-x': `${itemsTitleLastWordX}px`,
            '--title-line-y': `${itemsTitleLastWordY}px`,
          }"
        >
          <template v-if="!mobile">
            {{ selectedCategory.name }}
          </template>
          <span
            v-for="(item, index) in selectedCategory.name.split(' ')"
            v-else
            :key="index"
            ref="itemsTitleLastWord"
            class="styled-title__word"
          >
            {{ item }}
          </span>
        </StyledTitle>

        <div
          v-if="selectedCategoryItems && showSelectedCategoryItems"
          class="pixel-picks__items"
          :class="{ 'pixel-picks__items--vote-ended': eventEnded }"
        >
          <!-- :key="`${selectedCategory.id}-${item.id}-${index}`" -->

          <div
            v-for="(item, index) in selectedCategoryItems"
            :key="`${selectedCategory.id}-${index}`"
            v-observable="{ callback: (visible: any, entry: any) => visible ? addElToStack(entry.target, index) : null, intersection: { threshold: 0.3 }, throttle: 250 }"
            class="pixel-picks__items__item"
            :style="{ visibility: 'hidden' }"
          >
            <div class="pixel-picks__items__item__percentage">
              {{ formatPercentage(item.percentage ? item.percentage : 0) }}
            </div>
            <div
              class="pixel-picks__items__item__img"
              :class="{ 'pixel-picks-winner': eventEnded && item.winner }"
              :style="{ backgroundImage: `url(${item.image})` }"
            ></div>
            <div
              v-if="!eventEnded"
              class="pixel-picks__button"
              :class="{
                'pixel-picks__button--voted':
                  selectedCategory.userVotedItem && selectedCategory.userVotedItem.id === item.id,
              }"
              @click="vote(item)"
            >
              {{
                selectedCategory.userVotedItem
                  ? selectedCategory.userVotedItem.id === item.id
                    ? 'YOUR PICK'
                    : 'CHANGE VOTE'
                  : 'VOTE'
              }}
            </div>
            <div class="pixel-picks__items__item__name">{{ item.name }}</div>
          </div>
        </div>
      </template>
    </CardWrapper>

    <DialogBox
      v-model="dialog.show"
      class="pixel-picks__dialog"
      :class="{ 'pixel-picks__dialog--login': dialog.message === 'login' }"
      :persistent="dialog.persistent"
      :show-close-btn="dialog.message !== 'loading'"
    >
      <template #body>
        <div v-if="dialog.message === 'details'" class="pixel-picks__dialog__content pixel-picks__dialog__details">
          <div class="pixel-picks__dialog__details__top">
            <p>Tell us which cosmetic items you want back in the Cash Shop coupon rotation!</p>
          </div>

          <div class="pixel-picks__line-star">
            <i class="line" />
            <i-local-star-bold class="star" />
            <i class="line" />
          </div>

          <div class="pixel-picks__dialog__details__middle">
            <p>When a Pixel Picks voting event is <b>active</b>:</p>
            <p>You can vote for <b>one option</b> in each <b>category</b>.</p>
            <div>
              Category options may include:
              <ul>
                <li><b>• Premium Surprise Style</b></li>
                <li><b>• Pixel Pick Royal Style</b></li>
                <li><b>• Change Royal Style</b></li>
                <li><b>• Damage Skin</b></li>
              </ul>
            </div>

            <p>Changed your mind? You can <b>change your votes</b> once per day (resets at <b>8:00 AM UTC</b>).</p>
            <p>
              Players must be <b>Lv. {{ minLevel }} and&nbsp;up</b> to participate.
            </p>
          </div>

          <div class="pixel-picks__line-star">
            <i class="line" />
            <i-local-star-bold class="star" />
            <i class="line" />
          </div>

          <div class="pixel-picks__dialog__details__bottom">
            Once the voting period <b>ends</b>, the community’s <b>top choices</b> will be included in an upcoming sales
            rotation for that category! The winning choices will be marked with a <span class="crown-icon" /> on the
            Pixel Picks page.
          </div>
        </div>

        <div v-else-if="dialog.message === 'loading'" class="pixel-picks__dialog__content pixel-picks__dialog__loading">
          <loading show />
        </div>

        <div v-else-if="dialog.message === 'login'" class="pixel-picks__dialog__content pixel-picks__dialog__login">
          <div class="pixel-picks__dialog__login__title">WELCOME!</div>

          <div class="pixel-picks__line-star">
            <i class="line" />
            <i-local-star-bold class="star" />
            <i class="line" />
          </div>

          <div class="pixel-picks__dialog__login__text1">Please log in to vote for Pixel Picks.</div>
          <div class="pixel-picks__dialog__login__text2">(*Must be Lv. {{ minLevel }} or above to participate)</div>

          <div class="pixel-picks__dialog__login__img">
            <div class="pixel-picks__button pixel-picks__button--border" @click="login">LOG IN</div>
          </div>
        </div>

        <div
          v-else
          class="pixel-picks__dialog__content pixel-picks__dialog__message"
          :class="dialog.style ? `pixel-picks__dialog__message--${dialog.style}` : ''"
        >
          {{ dialog.message }}
        </div>
      </template>
    </DialogBox>
  </div>
</template>

<script lang="ts" setup>
  import { useUserStore } from '@/store/User'
  import { cdnApi, gameApi, gameApiWithAuth } from '@/helpers/api'
  import { opts } from '@/helpers/responsive'
  import CardWrapper from '@/components/Common/CardWrapper.vue'
  import StyledTitle from '@/components/Common/TextBox/StyledTitle.vue'
  const { mobile } = useDisplay()

  interface IItem {
    id: number
    image: string
    name: string
    winner: boolean
    voted?: boolean
    percentage?: number
  }

  interface IVote {
    itemCategoryID: number
    itemID: number
    percentage: number
    isRevoted: boolean
  }

  interface UserVotes {
    eventID?: number
    membershipUserNo?: number

    votes?: IVote[]
  }

  interface ICategory {
    name: string
    color: string
    id: number
    Children: IItem[]
    userVotedItem?: IItem & { voteData?: IVote }
  }

  interface IEvent {
    startTime: string
    endTime: string
    ended: boolean | undefined
    id: number | undefined
    minGameLevel: number
    Children: ICategory[]
  }

  onMounted(async () => {
    document.body.classList.add('pixel-picks-page')
  })

  onBeforeMount(async () => {
    try {
      loadingEvent.value = true

      await Promise.all([getEventCdnData(), userStore.getUserInfo()])

      if (userStore.isLoggedIn) await Promise.all([getUserVotes(), getAllVotes()])
      else await getAllVotes()

      updateEventWithVotes()

      loadingEvent.value = false
      setTimeout(() => {
        updateHeaderHeight()
        adjustMenuPosition()
        calculateMobileItemsTitleSpace()
        window.addEventListener('scroll', onScroll)
        window.addEventListener('resize', onResize)
        showStickyMenu.value = true
      }, opts.debounce + 10)
    } catch {}
  })

  onBeforeUnmount(() => {
    document.body.classList.remove('pixel-picks-page')
    window.removeEventListener('scroll', onScroll)
    window.removeEventListener('resize', onResize)
  })

  const ppBaseAPI = computed(() => `/pixel-picks/events/${event.value.id}`)

  const event = ref<IEvent>({
    startTime: '',
    endTime: '',
    id: undefined,
    ended: undefined,
    minGameLevel: 101,
    Children: [],
  })

  const userStore = useUserStore()
  const mobileMenuExpanded = ref(false)
  // const menuStyles = ref({ bottom: '0px' })
  // const footerEl = ref<HTMLElement | null>(null)
  const showStickyMenu = ref(false)
  const itemsTitleLastWord = ref<HTMLElement[] | null>(null)
  const itemsTitleLastWordX = ref(0)
  const itemsTitleLastWordY = ref(0)
  // const itemsTitleMobile = ref<HTMLElement | null>(null)
  const itemsTitleMobile = ref<InstanceType<typeof StyledTitle> | null>(null)

  const loadingEvent = ref(false)
  const userVotes = ref<UserVotes>({
    eventID: undefined,
    membershipUserNo: undefined,
    votes: [],
  })
  const allVotes = ref<UserVotes>({ eventID: undefined, votes: [] })

  const eventEnded = computed(() => event.value.ended)
  const categories = computed(() => event.value.Children)
  const selectedCategoryIndex = ref(0)
  const selectedCategory = computed(() => event.value.Children[selectedCategoryIndex.value])
  const selectedCategoryItems = computed(() => {
    const items = selectedCategory.value.Children
    return items.sort((a, b) => (b.percentage || 0) - (a.percentage || 0))
  })

  const showSelectedCategoryItems = ref(true)

  const dialog = ref<{
    show: boolean
    message: string
    style: string | null
    persistent: boolean
  }>({
    show: false,
    message: '',
    style: null,
    persistent: false,
  })

  const minLevel = computed(() => event.value.minGameLevel)

  const headerHeight = ref(0)
  const itemsCardEl = ref<InstanceType<typeof CardWrapper> | null>(null)
  const itemsBoxTopPosition = ref(0)
  const menuMarginRight = ref(0)

  interface StackEl {
    el: HTMLElement
    index: number
  }

  const stackEls = ref<StackEl[]>([])

  const addElToStack = (el: HTMLElement, index: number) => {
    if (el.style.visibility === 'hidden') {
      stackEls.value.push({ el, index })
    }
  }

  watchDebounced(
    stackEls,
    (stack) => {
      const els = stack.sort((a, b) => a.index - b.index).map((el) => el.el)

      if (stack.length > 0) {
        gsap.fromTo(
          els,
          { opacity: 0, y: -20, visibility: 'hidden' }, // Initial state
          { opacity: 1, y: 0, visibility: 'visible', duration: 0.3, stagger: 0.1 } // Final state
        )
        stack.splice(0, stack.length)
      }
    },
    { deep: true, debounce: 250 }
  )

  const onScroll = () => {
    adjustMenuPosition()
  }

  const onResize = async () => {
    updateHeaderHeight()
    adjustMenuPosition()
    calculateMobileItemsTitleSpace()
  }

  const calculateMobileItemsTitleSpace = () => {
    try {
      if (mobile.value && itemsTitleLastWord.value && itemsTitleLastWord.value.length > 0 && itemsTitleMobile.value) {
        const parentRect = itemsTitleMobile.value.$el.getBoundingClientRect()
        const lastWordElement = itemsTitleLastWord.value[itemsTitleLastWord.value.length - 1]
        const lastWordRect = lastWordElement.getBoundingClientRect()
        itemsTitleLastWordX.value = parentRect.right - lastWordRect.right
        itemsTitleLastWordY.value = (lastWordRect.top + lastWordRect.bottom) / 2 - parentRect.top
      }
    } catch {}
  }

  const adjustMenuPosition = () => {
    try {
      // if (mobile.value) {
      //   if (document.getElementsByClassName('media-platforms')) {
      //     footerEl.value = document.getElementsByClassName('media-platforms')[0] as HTMLElement

      //     const footerRect = footerEl.value.getBoundingClientRect()
      //     const viewportHeight = window.innerHeight

      //     if (footerRect.top < viewportHeight) {
      //       menuStyles.value = { bottom: `${viewportHeight - footerRect.top}px` }
      //     } else {
      //       menuStyles.value = { bottom: '0px' } // Default to bottom 0
      //     }
      //   }
      // }

      if (itemsCardEl.value) {
        const rect = itemsCardEl.value.$el.getBoundingClientRect()
        const clientWidth = document.documentElement.clientWidth || document.body.clientWidth
        menuMarginRight.value = (clientWidth - rect.width) / 2
        itemsBoxTopPosition.value = rect.top + window.scrollY
      }
    } catch {}
  }

  const updateHeaderHeight = () => {
    try {
      const headerEl = document.querySelector('header') as HTMLElement
      if (headerEl) headerHeight.value = headerEl.clientHeight
    } catch {}
  }

  watch(
    () => mobile.value,
    async (value) => {
      if (value) {
        showStickyMenu.value = false
        await nextTick()
        showStickyMenu.value = true
      }
    }
  )
  watch(
    () => dialog.value.message,
    (value) => {
      if (!['details', 'login'].includes(value)) {
        dialog.value.persistent = true
      } else {
        dialog.value.persistent = false
      }
    }
  )

  const openDialog = (message: string, code?: string | number) => {
    if (message === 'result' && code) {
      showMessage(code)
    } else {
      dialog.value.message = message || ''
      dialog.value.style = null
    }
    dialog.value.show = true
  }

  const showMessage = (code: number | string) => {
    switch (code) {
      case 'success':
        dialog.value.message = 'Thank you for voting! You can change your vote after 8:00 AM UTC.'
        dialog.value.style = 'vote-success'
        return
      case '22016':
      case 'round-ended':
        dialog.value.message =
          'This round of voting has ended. The winning picks will appear in the Cash Shop within the next months. Check back soon for another round of items!'
        dialog.value.style = 'round-ended'
        return
      case '22017':
      case '22003':
        dialog.value.message = `You must be at least Lv. ${minLevel.value} in order to vote.`
        dialog.value.style = 'low-level'
        return
      case '22018':
      case 'already-voted':
        dialog.value.message = 'You have already voted. You can change your vote after 8:00 AM UTC.'
        dialog.value.style = 'already-voted'
        return
      case '22010':
        dialog.value.message = 'Your account must be in good standing in order to vote.'
        dialog.value.style = 'not-eligible'
        return

      default:
        dialog.value.message = 'An error has occurred. Please try again later.'
        dialog.value.style = 'error'
    }
  }

  const login = () => {
    window.nexon.sso.login()
  }

  const setSelectedCategory = async (categoryIndex: number) => {
    selectedCategoryIndex.value = categoryIndex
    await nextTick()
    calculateMobileItemsTitleSpace()
    window.scrollTo({
      top: itemsBoxTopPosition.value - 10 - (headerHeight.value ? headerHeight.value : 0),
      behavior: 'smooth',
    })
  }

  const getEventCdnData = async () => {
    try {
      const { data } = await cdnApi.get<IEvent>('pixel-picks')
      if (data) event.value = data
    } catch (error) {}
  }

  const getUserVotes = async () => {
    const { data } = await gameApiWithAuth.get(`${ppBaseAPI.value}/user-votes`)

    if (data) userVotes.value = { ...data }
  }

  const getAllVotes = async () => {
    const { data } = await gameApi.get(`${ppBaseAPI.value}/votes`)

    if (data) allVotes.value = { ...data }
  }

  const updateEventWithVotes = (userVotesEnabled = true, allVotesEnabled = true) => {
    if (event.value.Children.length > 0) {
      // Create maps for quick lookups
      const userVotesMap =
        userVotesEnabled && userVotes.value.votes
          ? new Map(userVotes.value.votes.map((vote) => [vote.itemCategoryID, vote]))
          : null

      const allVotesMap =
        allVotesEnabled && allVotes.value.votes
          ? new Map(allVotes.value.votes.map((vote) => [`${vote.itemCategoryID}-${vote.itemID}`, vote.percentage]))
          : null

      // Iterate over categories and items
      event.value.Children.forEach((category) => {
        const userVote = userVotesMap?.get(category.id)

        category.Children.forEach((item) => {
          const key = `${category.id}-${item.id}`

          // Process user votes
          if (userVote && item.id === userVote.itemID) {
            category.userVotedItem = { ...item, voteData: userVote }
          }

          // Process all votes
          if (allVotesMap?.has(key)) {
            item.percentage = allVotesMap.get(key)

            if (
              category.userVotedItem &&
              category.userVotedItem.voteData &&
              item.percentage &&
              category.userVotedItem.id === item.id
            ) {
              category.userVotedItem.voteData.percentage = item.percentage
            }
          } else if (item.percentage) {
            item.percentage = 0 // reset percentage if not found in all votes
          }
        })
      })
    }
  }

  const vote = async (item: IItem) => {
    if (selectedCategory.value.userVotedItem && selectedCategory.value.userVotedItem.id === item.id) {
      return // this is your pick, not clickable
    } else if (eventEnded.value) return openDialog('result', 'round-ended')
    else if (!userStore.isLoggedIn) return openDialog('login')

    try {
      openDialog('loading')

      await gameApiWithAuth.post(`${ppBaseAPI.value}/vote`, {
        itemCategoryID: selectedCategory.value.id,
        itemID: item.id,
      })

      await Promise.all([getUserVotes(), getAllVotes()])

      updateEventWithVotes()

      showMessage('success')
    } catch (e: any) {
      if (e.response && e.response.headers && e.response.headers['x-arena-web-errorcode']) {
        showMessage(e.response.headers['x-arena-web-errorcode'])
      } else {
        showMessage('error')
      }
    }
  }

  const formatPercentage = (percentage: number) => {
    try {
      const truncated = Math.trunc(percentage * 100) / 100 // Truncate to two decimal places
      return `${truncated.toFixed(2)}%`
    } catch {
      return `${percentage}%`
    }
  }
</script>

<style lang="scss" scoped>
  .pixel-picks {
    $item-width-ratio: 284;
    $item-height-ratio: 213;
    $button-hover-bg: #1657cb;
    font-size: pxToRem(24, $round: false);

    .pixel-picks-winner {
      position: relative;
      &:before {
        border-width: pxToRem(8.1) !important;
        border-radius: inherit;
        border-color: #f97b3f !important;
      }

      &:after {
        content: '';
        position: absolute;
        display: inline-block;
        width: pxToRem(70.86, $round: false);
        height: pxToRem(73.9, $round: false);
        top: pxToRem(-32, $round: false);
        left: pxToRem(-31, $round: false);
        background-image: url('@/assets/imgs/pixel-picks/crown-winner.png');
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        z-index: 2;
      }
    }
    .pixel-picks__bg {
      &-red {
        background-color: #f44336 !important;
      }
      &-purple {
        background-color: #c000cb !important;
      }
      &-dark-blue {
        background-color: #3f51b5 !important;
      }

      &-light-blue {
        background-color: #2196f3 !important;
      }

      &-teal {
        background-color: #009688 !important;
      }

      &-green {
        background-color: #8bc34a !important;
      }

      &-gold {
        background-color: #ff9800 !important;
      }

      &-brown {
        background-color: #795548 !important;
      }

      &-silver {
        background-color: #9e9e9e !important;
      }

      &-gray {
        background-color: #607d8b !important;
      }
    }

    .pixel-picks__box {
      margin-bottom: pxToRem(30);

      :deep() {
        .card__content {
          padding: pxToRem(25, $round: false) pxToRem(30, $round: false) pxToRem(30, $round: false);
        }
      }

      .loading {
        height: pxToRem(200);
        :deep(.loading__img) {
          background-size: pxToRem(112);
        }
      }

      .styled-title {
        font-size: pxToRem(48);
        margin-bottom: pxToRem(6);
        text-transform: uppercase;
      }

      &--items {
        // position: relative;
        // overflow: initial !important;
        margin-bottom: 0;
      }
    }

    &__menu {
      $width: 170px;
      position: sticky;
      font-family: 'Glory';
      font-size: pxToRem(14);
      font-weight: bold;
      top: 100px;
      color: #fff;
      left: 0;
      display: block;
      width: pxToRem($width);
      height: 0;
      margin-left: auto;
      // margin-top: pxToRem(50);
      // margin-bottom: pxToRem(-20);
      z-index: 10;

      margin-top: pxToRem(-218);
      + * {
        margin-top: pxToRem(218);
      }

      .styled-scrollbar {
        width: pxToRem(170);
        border-radius: pxToRem(10);
        padding: pxToRem(3, $round: false) pxToRem(5, $round: false);
        background-color: #313130;
        overflow: auto;
        margin-top: 0px;
      }

      &__item {
        $this: &;

        position: relative;
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        background-color: #d3d2d2;
        margin-top: 2px;
        margin-bottom: 2px;
        border-radius: pxToRem(5.1);
        line-height: 0.9;
        text-align: center;
        padding-top: pxToRem(3);
        padding-bottom: pxToRem(3);
        padding-right: pxToRem(5);

        &__title {
          flex-basis: 0;
          flex-grow: 1;
          max-width: 100%;
          padding: 0 pxToRem(25);
        }

        &:after {
          content: '';
          width: pxToRem(28.35, $round: false);
          min-width: pxToRem(28.35, $round: false);
          height: pxToRem(29.36, $round: false);
          min-height: pxToRem(29.36, $round: false);
          background-image: url('@/assets/imgs/pixel-picks/not-voted.png');
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
          margin-left: auto;
        }

        &--voted {
          &:after {
            background-image: url('@/assets/imgs/pixel-picks/voted.png');
          }
        }

        &.active,
        &:hover {
          cursor: pointer;
          &:before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            pointer-events: none;
            width: 100%;
            height: 100%;
            border-radius: inherit;
            border: 1px solid #fff;
          }
        }

        &:nth-child(n + 6):nth-child(-n + 9) {
          // 6, 7, 8, 9 children
          #{$this}__title {
            padding: 0 pxToRem(10);
          }
        }
      }

      @media (min-width: 2000px) {
        margin-right: pxToRem(-$width - 20) !important;
      }

      @media (min-width: 2010px) {
        margin-right: pxToRem(-$width - 20) !important;
      }
    }

    &__button {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      text-align: center;
      background-color: #2677db;
      transition: background-color 0.3s;
      font-size: pxToRem(30, $round: false);
      min-height: pxToRem(50, $round: false);
      min-width: pxToRem(204, $round: false);
      padding: pxToRem(10, $round: false);
      border-radius: pxToRem(35, $round: false);
      line-height: 0.9;
      color: #fff;
      z-index: 1;

      &:hover {
        background-color: $button-hover-bg;
        transition: background-color 0.3s;
        cursor: pointer;
      }

      &--border {
        border: pxToRem(5px, $round: false) solid #fff;
        min-height: pxToRem(60, $round: false);
        min-width: pxToRem(212, $round: false);
      }

      &--voted {
        background-color: #53bbec;
        &:hover {
          background-color: #53bbec;
          cursor: default;
        }
      }
    }

    .pixel-picks__info {
      $color: #313130;

      font-family: 'Glegoo';
      font-weight: bold;
      background-color: $color;
      color: #fff;
      text-align: center;
      :deep() {
        .card__content {
          padding-top: pxToRem(18);
        }
      }

      &__title {
        font-weight: bold;
      }
      &__lvl {
        font-size: pxToRem(18);
      }

      &__link {
        position: relative;
        color: #fb9c3c;
        transition: color 0.2s;
        &:before {
          content: '';
          position: absolute;
          width: 100%;
          height: pxToRem(2.1, $round: false);
          background-color: #fb9c3c;
          left: 0;
          bottom: pxToRem(4);
          transition: background-color 0.2s;
        }
        &:hover {
          cursor: pointer;
          color: #ffe97a;
          transition: color 0.2s;

          &:before {
            background-color: #ffe97a;
            transition: background-color 0.2s;
          }
        }
      }
      &__voting-period {
        display: flex;
        flex-wrap: nowrap;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: pxToRem(70);
        background-image: url('@/assets/imgs/pixel-picks/voting-period-bg.png');
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        color: $color;
        line-height: 1;
        margin-top: pxToRem(23);

        &__title {
          display: flex;
          flex-wrap: nowrap;
          align-items: center;
          font-family: 'Glory';
          font-size: pxToRem(30);
          margin-bottom: pxToRem(1);
          .star {
            width: pxToRem(13);
            height: pxToRem(13);
            color: #ffe97a;
            margin: 0 pxToRem(8);
          }
        }

        &__dates {
          font-size: pxToRem(22);
        }
      }
    }

    .pixel-picks__categories {
      font-family: 'Glory';
      font-weight: bold;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      line-height: 1.2;
      min-height: pxToRem(200);
      // margin-top: pxToRem(-14);
      margin-left: pxToRem(-15, $round: false);
      margin-right: pxToRem(-15, $round: false);

      &__category-wrapper {
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        flex: 0 0 20%;
        max-width: 20%;
        padding: 0 pxToRem(15, $round: false);
      }
      &__category {
        position: relative;
        flex: 0 0 100%;
        max-width: 100%;
        position: relative;
        // height: pxToRem(215.6);
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        border-radius: pxToRem(10);
        background-color: #d3d2d2;
        margin-top: pxToRem(31);
        margin-bottom: pxToRem(25);
        // padding: 0 19%;
        color: #504d4a;
        aspect-ratio: #{$item-width-ratio}/#{$item-height-ratio};
        padding-top: #{math.div($item-height-ratio, $item-width-ratio) * 100%}; // for old browsers that don't support aspect-ratio

        &__name {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: center;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          font-size: pxToRem(24, $round: false);
          text-align: center;
          color: #fff;
          padding: 0 18%;

          &--w5 {
            padding: 0 10%;
          }

          &--w2 {
            padding: 0 24%;
          }
          @media (min-width: 1921px) {
            padding: 0 18.65%;

            &--w5 {
              padding: 0 10%;
            }

            &--w2 {
              padding: 0 22%;
            }
          }
        }

        .pixel-picks__button {
          position: absolute;
          bottom: pxToRem(-30);
          left: 50%;
          transform: translateX(-50%);
        }

        &__item-percentage {
          position: absolute;
          top: pxToRem(-15);
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: pxToRem(24);
          background-color: #504d4a;
          color: #fff;
          width: pxToRem(120);
          height: pxToRem(30);
          border-radius: pxToRem(15);
          line-height: 0.9;
          z-index: 2;
        }

        &__item-name {
          flex: 0 0 100%;
          max-width: 100%;
          font-size: pxToRem(24);
          text-align: center;
          color: #504d4a;
          margin-bottom: pxToRem(7);
        }

        &--voted {
          background-color: transparent;
          background-repeat: no-repeat;
          background-position: center;
          background-size: cover;
          margin-bottom: pxToRem(6);
          &:before {
            content: '';
            width: 100%;
            height: 100%;
            pointer-events: none;
            position: absolute;
            top: 0;
            left: 0;
            border: pxToRem(4.1) solid #504d4a;
            border-radius: inherit;
            z-index: 1;
          }
        }

        &:hover {
          cursor: pointer;
          .pixel-picks__button {
            background-color: $button-hover-bg;
            transition: background-color 0.3s;
          }
        }
      }
    }

    .pixel-picks__items {
      font-family: 'Glory';
      font-weight: bold;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      line-height: 1.2;
      margin-top: pxToRem(-8);
      margin-bottom: pxToRem(-4);
      margin-left: pxToRem(-15, $round: false);
      margin-right: pxToRem(-15, $round: false);

      &__item {
        $this: &;

        display: flex;
        flex-wrap: wrap;
        position: relative;
        align-content: flex-start;
        flex: 0 20%;
        max-width: 20%;
        padding: 0 pxToRem(15, $round: false);
        margin-top: pxToRem(40);

        &__percentage {
          position: absolute;
          top: pxToRem(-15);
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: pxToRem(24);
          background-color: #504d4a;
          color: #fff;
          width: pxToRem(120);
          height: pxToRem(30);
          border-radius: pxToRem(15);
          line-height: 0.9;
          z-index: 2;
        }

        &__img {
          position: relative;
          flex: 0 0 100%;
          max-width: 100%;
          // border: pxToRem(4.1) solid #504d4a;
          border-radius: pxToRem(10);
          // height: pxToRem(215.6);
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          aspect-ratio: #{$item-width-ratio}/#{$item-height-ratio};
          padding-top: #{math.div($item-height-ratio, $item-width-ratio) * 100%}; // for old browsers that don't support aspect-ratio
          &:before {
            content: '';
            position: absolute;
            width: 100%;
            height: 100%;
            pointer-events: none;
            top: 0;
            left: 0;
            border: pxToRem(4.1) solid #504d4a;
            border-radius: inherit;
            z-index: 1;
          }
        }

        .pixel-picks__button {
          z-index: 2;
          margin-left: auto;
          margin-right: auto;
          margin-top: pxToRem(-27);
        }

        &__name {
          flex: 0 0 100%;
          max-width: 100%;
          text-align: center;
          margin-top: pxToRem(8);
          line-height: 1;
          font-size: pxToRem(22);
        }
      }

      &.pixel-picks__items--vote-ended {
        $this: &;

        .pixel-picks__items__item {
          &__name {
            margin-top: pxToRem(9);
          }
        }
      }
    }
  }

  .tablet,
  .desktop {
    .pixel-picks {
      .pixel-picks__menu {
        .expand-transition-enter-active,
        .expand-transition-leave-active {
          // we don't need transition for desktop and tablet
          transition-duration: 0s !important;
        }
      }
    }
  }

  @media #{$smallDesktopOnly} {
    .pixel-picks {
      @function pxToRemSmallDesktop($px, $fontBase: 20, $round: true, $fractionDigits: 3) {
        @return pxToRem($px, $fontBase, $round, $fractionDigits);
      }
      &__menu {
        $width: 169px;
        font-size: pxToRemSmallDesktop(14);
        width: pxToRemSmallDesktop($width);
        // margin-top: pxToRemSmallDesktop(50);
        // margin-bottom: pxToRemSmallDesktop(-20);
        margin-top: pxToRemSmallDesktop(-190);
        // margin-bottom: pxToRemSmallDesktop(190);
        + * {
          margin-top: pxToRemSmallDesktop(190);
        }

        .styled-scrollbar {
          width: pxToRemSmallDesktop($width);
          border-radius: pxToRemSmallDesktop(10);
          padding: pxToRemSmallDesktop(3, $round: false) pxToRemSmallDesktop(5, $round: false);
        }

        &__item {
          $this: &;
          border-radius: pxToRemSmallDesktop(5.1);
          padding-top: pxToRemSmallDesktop(3);
          padding-bottom: pxToRemSmallDesktop(3);
          padding-right: pxToRemSmallDesktop(5);

          &__title {
            padding: 0 pxToRemSmallDesktop(23);
          }

          &:after {
            width: pxToRemSmallDesktop(28.35, $round: false);
            min-width: pxToRemSmallDesktop(28.35, $round: false);
            height: pxToRemSmallDesktop(29.36, $round: false);
            min-height: pxToRemSmallDesktop(29.36, $round: false);
          }

          &:nth-child(n + 6):nth-child(-n + 9) {
            // 6, 7, 8, 9 children
            #{$this}__title {
              padding: 0 pxToRemSmallDesktop(10);
            }
          }
        }
      }

      .pixel-picks__categories {
        &__category {
          &__name {
            &--w2 {
              padding: 0 25%;
            }
          }
        }
      }
    }
  }

  @media #{$tablet} {
    .pixel-picks {
      font-size: pxToRemTablet(24, $round: false);

      .pixel-picks-winner {
        &:before {
          border-width: pxToRemTablet(8.1) !important;
        }
        &:after {
          width: pxToRemTablet(70.86, $round: false);
          height: pxToRemTablet(73.9, $round: false);
          top: pxToRemTablet(-32, $round: false);
          left: pxToRemTablet(-31, $round: false);
        }
      }

      .pixel-picks__box {
        margin-bottom: pxToRemTablet(30);

        :deep() {
          .card__content {
            padding: pxToRemTablet(25, $round: false) pxToRemTablet(30, $round: false) pxToRemTablet(30, $round: false);
          }
        }

        .loading {
          height: pxToRemTablet(200);
          :deep(.loading__img) {
            background-size: pxToRemTablet(112);
          }
        }

        .styled-title {
          font-size: pxToRemTablet(48);
          margin-bottom: pxToRemTablet(6);

          :deep() {
            .line {
              height: pxToRemTablet(5);
            }
          }
        }
      }

      &__menu {
        $width: 169px;
        font-size: pxToRemTablet(14);
        width: pxToRemTablet($width);
        // margin-top: pxToRemTablet(50);
        // margin-bottom: pxToRemTablet(-20);
        // margin-top: pxToRemTablet(-218);
        // margin-bottom: pxToRemTablet(218);
        margin-top: pxToRemTablet(-300);
        // margin-bottom: pxToRemTablet(300);
        + * {
          margin-top: pxToRemTablet(300);
        }

        .styled-scrollbar {
          width: pxToRemTablet($width);
          border-radius: pxToRemTablet(10);
          padding: pxToRemTablet(3, $round: false) pxToRemTablet(5, $round: false);
        }

        &__item {
          $this: &;
          border-radius: pxToRemTablet(5.1);
          padding-top: pxToRemTablet(3);
          padding-bottom: pxToRemTablet(3);
          padding-right: pxToRemTablet(5);

          &__title {
            padding: 0 pxToRemTablet(25);
          }

          &:after {
            content: '';
            width: pxToRemTablet(28.35, $round: false);
            min-width: pxToRemTablet(28.35, $round: false);
            height: pxToRemTablet(29.36, $round: false);
            min-height: pxToRemTablet(29.36, $round: false);
          }

          &:nth-child(n + 6):nth-child(-n + 9) {
            // 6, 7, 8, 9 children
            #{$this}__title {
              padding: 0 pxToRemTablet(10);
            }
          }
        }
      }

      &__button {
        font-size: pxToRemTablet(30);
        min-height: pxToRemTablet(50);
        min-width: pxToRemTablet(204);
        padding: pxToRemTablet(10);
        border-radius: pxToRemTablet(35);

        &--border {
          border-width: pxToRemTablet(5px);
          min-height: pxToRemTablet(60);
          min-width: pxToRemTablet(212);
          margin-bottom: pxToRemTablet(-5);
        }
      }

      .pixel-picks__info {
        :deep() {
          .card__content {
            padding-top: pxToRemTablet(21);
          }
        }

        &__title {
          line-height: 1.28;
          max-width: pxToRemTablet(650);
          margin-left: auto;
          margin-right: auto;
        }
        &__lvl {
          font-size: pxToRemTablet(18);
          margin-top: pxToRemTablet(2);
        }

        &__link {
          &:before {
            height: pxToRemTablet(2.1, $round: false);
            bottom: pxToRemTablet(6);
          }
        }

        &__voting-period {
          height: pxToRemTablet(70);
          margin-top: pxToRemTablet(23);

          &__title {
            font-size: pxToRemTablet(30);
            margin-bottom: pxToRemTablet(1);
            .star {
              width: pxToRemTablet(13);
              height: pxToRemTablet(13);
              margin: 0 pxToRemTablet(8);
            }
          }

          &__dates {
            font-size: pxToRemTablet(22);
          }
        }
      }

      .pixel-picks__categories {
        min-height: pxToRemTablet(200);
        margin: 0 pxToRemTablet(-18, $round: false);

        &__category-wrapper {
          flex: 0 0 33.33%;
          max-width: 33.33%;
          padding: 0 pxToRemTablet(18, $round: false);
        }
        &__category {
          // height: pxToRemTablet(215.6);
          border-radius: pxToRemTablet(10);
          margin-top: pxToRemTablet(29);
          margin-bottom: pxToRemTablet(25);
          // padding: 0 16%;

          &__name {
            font-size: pxToRemTablet(24, $round: false);
            padding: 0 16%;

            &--w5 {
              padding: 0 8%;
            }

            &--w2 {
              padding: 0 21%;
            }
          }

          .pixel-picks__button {
            bottom: pxToRemTablet(-24);
          }

          &__item-percentage {
            top: pxToRemTablet(-15);
            font-size: pxToRemTablet(24);
            width: pxToRemTablet(120);
            height: pxToRemTablet(30);
            border-radius: pxToRemTablet(15);
          }

          &__item-name {
            font-size: pxToRemTablet(24);
            margin-bottom: pxToRemTablet(8);
          }

          &--voted {
            margin-bottom: pxToRemTablet(6);
            &:before {
              border-width: pxToRemTablet(4.1);
            }
          }
        }
      }

      .pixel-picks__items {
        margin-top: pxToRemTablet(-8);
        margin-bottom: pxToRemTablet(-4);
        margin-left: pxToRemTablet(-18, $round: false);
        margin-right: pxToRemTablet(-18, $round: false);

        &__item {
          $this: &;

          flex: 0 33.33%;
          max-width: 33.33%;
          padding: 0 pxToRemTablet(18, $round: false);
          margin-top: pxToRemTablet(40);

          &__percentage {
            top: pxToRemTablet(-15);
            font-size: pxToRemTablet(24);
            width: pxToRemTablet(120);
            height: pxToRemTablet(30);
            border-radius: pxToRemTablet(15);
          }

          &__img {
            // height: pxToRemTablet(215.6);
            border-radius: pxToRemTablet(10);
            &:before {
              border-width: pxToRemTablet(4.1);
            }
          }

          .pixel-picks__button {
            // top: pxToRemTablet(188);
            margin-top: pxToRemTablet(-27);
          }

          &__name {
            margin-top: pxToRemTablet(8);
            font-size: pxToRemTablet(22);
          }
        }

        &.pixel-picks__items--vote-ended {
          $this: &;

          .pixel-picks__items__item {
            &__name {
              margin-top: pxToRemTablet(9);
            }
          }
        }
      }
    }
  }

  @media #{$mobile} {
    .pixel-picks {
      font-size: pxToRemMobile360(24, $round: false);

      .pixel-picks-winner {
        &:before {
          border-width: pxToRemMobile360(8.1) !important;
        }

        &:after {
          width: pxToRemMobile360(70.86, $round: false);
          height: pxToRemMobile360(73.9, $round: false);
          top: pxToRemMobile360(-32, $round: false);
          left: pxToRemMobile360(-31, $round: false);
        }
      }

      .pixel-picks__box {
        margin-bottom: pxToRemMobile360(20);

        :deep() {
          .card__content {
            padding: pxToRemMobile360(15, $round: false) pxToRemMobile360(30, $round: false)
              pxToRemMobile360(20, $round: false) pxToRemMobile360(30, $round: false);
          }
        }

        .loading {
          height: pxToRemMobile360(200);
          :deep(.loading__img) {
            background-size: pxToRemMobile360(112);
          }
        }

        .styled-title {
          font-size: pxToRemMobile360(30);
          margin-bottom: pxToRemMobile360(6);

          :deep() {
            > span {
              white-space: initial;
            }
            .line {
              height: pxToRemMobile360(5);
            }
          }
        }

        &--items {
          margin: 0;
          .styled-title {
            position: relative;

            .styled-title__word {
              &:after {
                content: ' ';
              }
            }
            :deep() {
              $star-size: 1em;

              > span {
                padding: 0;
              }

              .star {
                position: absolute;
                height: $star-size;
                width: $star-size;
                top: calc(var(--title-line-y) - math.div($star-size, 2));
                &.left {
                  left: calc(var(--title-line-x) - $star-size - 10px);
                }
                &.right {
                  right: calc(var(--title-line-x) - $star-size - 10px);
                }
              }
              .line {
                $height: 5;
                position: absolute;
                width: calc(var(--title-line-x) - $star-size);
                height: pxToRemMobile360($height);
                top: calc(var(--title-line-y) - pxToRemMobile360(math.div($height, 2)));
                &.left {
                  left: 0;
                }
                &.right {
                  right: 0;
                }
              }
            }
          }
        }
      }

      &__menu {
        position: fixed;
        font-size: pxToRemMobile360(20);
        top: initial !important;
        left: 50%;
        transform: translateX(-50%);
        width: pxToRemMobile360(340);
        max-width: 100%;
        bottom: 0%;
        height: initial !important;
        margin: 0;
        max-height: 100% !important;
        padding-left: pxToRemMobile360(10);
        padding-right: pxToRemMobile360(10);
        border-radius: pxToRemMobile360(10);
        background-color: #313130;
        padding: pxToRemMobile360(5, $round: false);

        &__top {
          $action-size: 24;
          display: flex;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: space-between;
          padding-left: pxToRemMobile360(5);
          padding-right: pxToRemMobile360(5);
          padding-top: pxToRemMobile360(2);
          padding-bottom: pxToRemMobile360(2);
          &__title {
            flex-grow: 1;
            flex-basis: 0;
            max-width: 100%;
            text-align: center;
            margin-left: pxToRemMobile360($action-size);
          }
          &__action {
            width: pxToRemMobile360($action-size);
            height: pxToRemMobile360($action-size);
            margin-left: auto;
            background-image: url('@/assets/imgs/pixel-picks/menu-minus.png');
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;

            &--expanded {
              background-image: url('@/assets/imgs/pixel-picks/menu-plus.png');
            }
          }

          &:hover {
            cursor: pointer;
            .pixel-picks__menu__top {
              &__action {
                background-image: url('@/assets/imgs/pixel-picks/menu-minus-hover.png');

                &--expanded {
                  background-image: url('@/assets/imgs/pixel-picks/menu-plus-hover.png');
                }
              }
            }
          }
        }

        .styled-scrollbar {
          width: 100%;
          background-color: transparent;
          border-radius: initial;
          padding: initial;
          max-height: calc(100vh - 160px) !important;
        }

        &__item {
          $this: &;
          border-radius: pxToRemMobile360(5);
          padding-top: pxToRemMobile360(2);
          padding-bottom: pxToRemMobile360(2);
          padding-right: pxToRemMobile360(23);
          padding-left: pxToRemMobile360(10);
          line-height: 0.9;
          &:first-child {
            margin-top: pxToRemMobile360(5);
          }
          &:last-child {
            margin-bottom: 0;
          }

          &__title {
            padding: 0 pxToRemMobile360(0);
            margin-bottom: pxToRemMobile360(3);
          }

          &:after {
            width: pxToRemMobile360(28, $round: false);
            min-width: pxToRemMobile360(28, $round: false);
            height: pxToRemMobile360(29, $round: false);
            min-height: pxToRemMobile360(29, $round: false);
          }

          &.active,
          &:hover {
            cursor: pointer;
            &:before {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              pointer-events: none;
              width: 100%;
              height: 100%;
              border-radius: inherit;
              border: 1px solid #fff;
            }
          }

          &:nth-child(n + 6):nth-child(-n + 9) {
            // 6, 7, 8, 9 children
            #{$this}__title {
              padding: 0 pxToRemMobile360(0);
            }
          }
        }
      }

      &__button {
        font-size: pxToRemMobile360(30);
        min-height: pxToRemMobile360(50);
        min-width: pxToRemMobile360(204);
        padding: pxToRemMobile360(10);
        border-radius: pxToRemMobile360(35);

        &--border {
          border-width: pxToRemMobile360(5px);
          min-height: pxToRemMobile360(60);
          min-width: pxToRemMobile360(212);
          margin-bottom: pxToRemMobile360(-5);
        }
      }

      .pixel-picks__info {
        margin-top: calc(pxToRemMobile360(262) - 116px);

        @media (max-width: 469px) and (pointer: fine) {
          margin-top: calc(pxToRemMobile360(255) - 116px);
        }

        @media (min-width: 470px) and (pointer: coarse) {
          margin-top: calc(pxToRemMobile360(262) - 95px);
        }

        @media (min-width: 470px) and (pointer: fine) {
          margin-top: calc(pxToRemMobile360(255) - 95px);
        }

        :deep() {
          .card__content {
            padding-top: pxToRemMobile360(12);
            padding-left: pxToRemMobile360(3);
            padding-right: pxToRemMobile360(3);
          }
        }

        &__title {
          font-size: pxToRemMobile360(18);
          line-height: 1.28;
          max-width: 100%;
          margin-left: auto;
          margin-right: auto;
        }
        &__lvl {
          font-size: pxToRemMobile360(14);
          margin-top: pxToRemMobile360(9);
        }

        &__link {
          &:before {
            height: pxToRemMobile360(2.1, $round: false);
            bottom: pxToRemMobile360(2);
          }
        }

        &__voting-period {
          background-image: url('@/assets/imgs/pixel-picks/voting-period-bg-mobile.png');
          height: pxToRemMobile360(70);
          margin-top: pxToRemMobile360(15);
          padding-bottom: pxToRemMobile360(1);

          &__title {
            font-size: pxToRemMobile360(24);
            margin-bottom: pxToRemMobile360(-1.5);
            .star {
              width: pxToRemMobile360(13);
              height: pxToRemMobile360(13);
              margin: 0 pxToRemMobile360(8);
            }
          }

          &__dates {
            font-size: pxToRemMobile360(18);
            max-width: pxToRemMobile360(260);
          }
        }
      }

      .pixel-picks__categories {
        min-height: pxToRemMobile360(200);
        margin: 0 pxToRemMobile360(-18, $round: false);

        &__category-wrapper {
          flex: 0 0 100%;
          max-width: 100%;
          padding: 0 pxToRemMobile360(18, $round: false);
          &:first-child {
            .pixel-picks__categories__category {
              margin-top: pxToRemMobile360(9);
              &--voted {
                margin-top: pxToRemMobile360(24);
              }
            }
          }
        }
        &__category {
          // height: pxToRemMobile360(215.6);
          border-radius: pxToRemMobile360(10);
          margin-top: pxToRemMobile360(20);
          margin-bottom: pxToRemMobile360(25);
          // padding: 0 16%;

          &__name {
            font-size: pxToRemMobile360(24, $round: false);

            &--w2 {
              padding: 0 22%;
            }
          }

          .pixel-picks__button {
            bottom: pxToRemMobile360(-24);
          }

          &__item-percentage {
            top: pxToRemMobile360(-15);
            font-size: pxToRemMobile360(24);
            width: pxToRemMobile360(120);
            height: pxToRemMobile360(30);
            border-radius: pxToRemMobile360(15);
          }

          &__item-name {
            font-size: pxToRemMobile360(24);
            margin-bottom: pxToRemMobile360(-6);
          }

          &--voted {
            // border-width: pxToRemMobile360(4.1);
            margin-top: pxToRemMobile360(35);
            margin-bottom: pxToRemMobile360(6);
            &:before {
              border-width: pxToRemMobile360(4.1);
            }
          }
        }
      }

      .pixel-picks__items {
        margin-top: pxToRemMobile360(-8);
        margin-bottom: pxToRemMobile360(-4);
        margin-left: pxToRemMobile360(-18, $round: false);
        margin-right: pxToRemMobile360(-18, $round: false);

        &__item {
          $this: &;

          flex: 0 100%;
          max-width: 100%;
          padding: 0 pxToRemMobile360(18, $round: false);
          margin-top: pxToRemMobile360(30);

          &:first-child {
            margin-top: pxToRemMobile360(32);
          }

          &__percentage {
            top: pxToRemMobile360(-15);
            font-size: pxToRemMobile360(24);
            width: pxToRemMobile360(120);
            height: pxToRemMobile360(30);
            border-radius: pxToRemMobile360(15);
          }

          &__img {
            // border-width: pxToRemMobile360(4.1);
            border-radius: pxToRemMobile360(10);
            // height: pxToRemMobile360(215.6);
            &:before {
              border-width: pxToRemMobile360(4.1);
            }
          }

          .pixel-picks__button {
            margin-top: pxToRemMobile360(-27);
          }

          &__name {
            margin-top: pxToRemMobile360(8);
            font-size: pxToRemMobile360(24);
          }

          &--winner {
            .pixel-picks__items__item__img {
              border-width: pxToRemMobile360(8.1);
              &:before {
                width: pxToRemMobile360(70.86, $round: false);
                height: pxToRemMobile360(73.9, $round: false);
                top: pxToRemMobile360(-42, $round: false);
                left: pxToRemMobile360(-41, $round: false);
              }
            }
          }
        }

        &.pixel-picks__items--vote-ended {
          $this: &;

          .pixel-picks__items__item {
            &__name {
              margin-top: pxToRemMobile360(9);
            }
          }
        }
      }
    }
  }
</style>

<style lang="scss">
  body.pixel-picks-page {
    @media #{$mobile} {
      .scroll-to-top-btn {
        bottom: pxToRemMobile360(50) !important;
        z-index: 9;
      }
    }
  }

  .pixel-picks__dialog {
    .pixel-picks__line-star {
      width: 100%;
      font-size: 36px; // default
      display: flex;
      justify-content: center;
      align-items: center;
      column-gap: 4px;

      .line {
        display: inline-flex;
        height: 0.15em;
        background-color: #fea922;
        border-radius: 5px;
        flex-grow: 1;
      }

      .star {
        color: #fea922;
        font-size: 20px;
        min-width: 20px; // prevent it from shrinking under flex
      }
    }

    .v-overlay__content {
      margin: 0;
      max-height: calc(100% - 40px);
      max-width: min(90%, 600px) !important;
      height: 100%;
    }

    .dialog-frame {
      max-height: 100%;
      margin-top: auto;
      margin-bottom: auto;

      .text-dialog {
        color: #504d4a !important;

        padding: 30px 32px !important;

        .styled-scrollbar {
          padding-left: 20px !important;
          padding-right: 20px !important;
        }
      }
    }

    .pixel-picks__dialog__details {
      display: flex;
      flex-wrap: nowrap;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      font-size: 18px;
      font-family: 'Glegoo';
      font-weight: bold;
      line-height: 1.35;
      padding-top: 12px;
      padding-bottom: 32px;

      b {
        text-shadow: 1px 0px 0px #504d4a;
      }

      p {
        margin-bottom: 12px;
      }

      ul {
        list-style-type: none;
        margin-bottom: 12px;
      }

      &__top {
        max-width: 360px;
      }

      &__middle {
        max-width: 420px;
        margin-top: 10px;
      }

      &__bottom {
        max-width: 456px;
        margin-top: 10px;
      }

      .crown-icon {
        display: inline-block;
        width: 22px;
        height: 24px;
        background-image: url('@/assets/imgs/pixel-picks/crown.png');
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        margin-bottom: -5px;
      }
    }

    .pixel-picks__dialog__message,
    .pixel-picks__dialog__loading,
    .pixel-picks__dialog__login {
      font-family: 'Glegoo';
      font-weight: bold;
      font-size: 18px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      max-height: calc(100vh - 104px); // 32px + 32px padding + 40px  v-overlay__content max-height
      height: 236px;
    }

    .pixel-picks__dialog__message {
      margin: 0 auto;
      line-height: 1.35;

      &--vote-success {
        max-width: 380px;
      }

      &--round-ended {
        max-width: 490px;
      }

      &--already-voted {
        max-width: 360px;
      }

      &--not-eligible {
        max-width: 340px;
      }
    }

    .pixel-picks__dialog__loading {
      .loading {
        height: 100%;
        max-height: 111px;

        .loading__img {
          background-size: contain;
        }
      }
    }

    .pixel-picks__dialog__login {
      height: auto;
      line-height: 1.35;

      &__title {
        font-family: 'Glory';
        font-weight: bold;
        font-size: 36px;
        margin-top: 8px;
        margin-bottom: 6px;
      }

      .pixel-picks__line-star {
        padding-left: 31px;
        padding-right: 31px;
        margin-bottom: 10px;
      }

      &__img {
        position: relative;
        width: 100%;
        height: 291px;
        background-image: url('@/assets/imgs/pixel-picks/login-bg.webp');
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        margin-top: 12px;
        margin-bottom: 25px;
      }

      .pixel-picks__button {
        position: absolute;
        font-size: 30px;
        min-height: 60px;
        min-width: 204px;
        padding: 10px;
        border-radius: 50px;
        bottom: -8px;
        left: 50%;
        transform: translateX(-50%);
      }
    }

    &--login {
      .dialog-frame {
        .text-dialog {
          padding-left: 0 !important;
          padding-right: 0 !important;
        }
      }
    }
  }

  @media #{$smallDesktopOnly} {
    @function pxToRemSmallDesktop($px, $fontBase: 18, $round: true, $fractionDigits: 3) {
      @return pxToRem($px, $fontBase, $round, $fractionDigits);
    }
    .pixel-picks__dialog {
      .pixel-picks__line-star {
        font-size: pxToRemSmallDesktop(36);
        column-gap: pxToRemSmallDesktop(4);

        .line {
          height: 0.15em;
          border-radius: pxToRemSmallDesktop(5);
        }
        .star {
          font-size: pxToRemSmallDesktop(20);
          min-width: pxToRemSmallDesktop(20);
        }
      }

      .v-overlay__content {
        max-height: calc(100% - 40px);
        max-width: min(90%, pxToRemSmallDesktop(608)) !important;
      }
      .dialog-frame {
        .text-dialog {
          padding: pxToRemSmallDesktop(30) pxToRemSmallDesktop(32) !important;
          .styled-scrollbar {
            padding-left: pxToRemSmallDesktop(20) !important;
            padding-right: pxToRemSmallDesktop(20) !important;
          }
        }
      }

      .pixel-picks__dialog__details {
        font-size: pxToRemSmallDesktop(18);
        padding-top: pxToRemSmallDesktop(12);
        padding-bottom: pxToRemSmallDesktop(32);

        p {
          margin-bottom: pxToRemSmallDesktop(12, $round: false);
        }
        ul {
          margin-bottom: pxToRemSmallDesktop(12);
        }

        &__top {
          max-width: pxToRemSmallDesktop(360);
        }

        &__middle {
          max-width: pxToRemSmallDesktop(420);
          margin-top: pxToRemSmallDesktop(10);
        }

        &__bottom {
          max-width: pxToRemSmallDesktop(456);
          margin-top: pxToRemSmallDesktop(10);
        }

        .crown-icon {
          width: pxToRemSmallDesktop(22);
          height: pxToRemSmallDesktop(24);
          margin-bottom: pxToRemSmallDesktop(-5);
        }
      }
      .pixel-picks__dialog__message,
      .pixel-picks__dialog__loading,
      .pixel-picks__dialog__login {
        font-size: pxToRemSmallDesktop(18);
        max-height: calc(100vh - 104px); // 32px + 32px padding + 40px  v-overlay__content max-height
        height: pxToRemSmallDesktop(236);
      }

      .pixel-picks__dialog__message {
        &--vote-success {
          max-width: pxToRemSmallDesktop(380);
        }
        &--round-ended {
          max-width: pxToRemSmallDesktop(490);
        }
        &--already-voted {
          max-width: pxToRemSmallDesktop(360);
        }
        &--not-eligible {
          max-width: pxToRemSmallDesktop(340);
        }
      }

      .pixel-picks__dialog__login {
        height: auto;
        &__title {
          font-size: pxToRemSmallDesktop(36);
          margin-top: pxToRemSmallDesktop(8.2, $round: false);
          margin-bottom: pxToRemSmallDesktop(6);
        }

        .pixel-picks__line-star {
          padding-left: pxToRemSmallDesktop(31);
          padding-right: pxToRemSmallDesktop(31);
          margin-bottom: pxToRemSmallDesktop(10);
        }

        &__img {
          height: pxToRemSmallDesktop(291);
          margin-top: pxToRemSmallDesktop(12, $round: false);
          margin-bottom: pxToRemSmallDesktop(25);
        }
        .pixel-picks__button {
          font-size: pxToRemSmallDesktop(30);
          min-height: pxToRemSmallDesktop(60);
          min-width: pxToRemSmallDesktop(204);
          padding: pxToRemSmallDesktop(10);
          border-radius: pxToRemSmallDesktop(50);
          bottom: pxToRemSmallDesktop(-8);
        }
      }
    }
  }

  @media (min-width: #{$mobileSize + 1px}) and (max-width: 700px) {
    // small tablet
    @function pxToRemSmallTablet($px, $fontBase: 26, $round: true, $fractionDigits: 3) {
      @return pxToRem($px, $fontBase, $round, $fractionDigits);
    }
    .pixel-picks__dialog {
      .pixel-picks__line-star {
        font-size: pxToRemSmallTablet(36);
        column-gap: pxToRemSmallTablet(4);

        .line {
          height: 0.15em;
          border-radius: pxToRemSmallTablet(5);
        }
        .star {
          font-size: pxToRemSmallTablet(20);
          min-width: pxToRemSmallTablet(20);
        }
      }

      .v-overlay__content {
        max-height: calc(100% - 40px);
        max-width: min(90%, pxToRemSmallTablet(608)) !important;
      }
      .dialog-frame {
        .text-dialog {
          padding: pxToRemSmallTablet(30) pxToRemSmallTablet(32) !important;
          .styled-scrollbar {
            padding-left: pxToRemSmallTablet(20) !important;
            padding-right: pxToRemSmallTablet(20) !important;
          }
        }
      }

      .pixel-picks__dialog__details {
        font-size: pxToRemSmallTablet(18);
        padding-top: pxToRemSmallTablet(12);
        padding-bottom: pxToRemSmallTablet(32);

        p {
          margin-bottom: pxToRemSmallTablet(12, $round: false);
        }
        ul {
          margin-bottom: pxToRemSmallTablet(12);
        }

        &__top {
          max-width: pxToRemSmallTablet(360);
        }

        &__middle {
          max-width: pxToRemSmallTablet(420);
          margin-top: pxToRemSmallTablet(10);
        }

        &__bottom {
          max-width: pxToRemSmallTablet(456);
          margin-top: pxToRemSmallTablet(10);
        }

        .crown-icon {
          width: pxToRemSmallTablet(22);
          height: pxToRemSmallTablet(24);
          margin-bottom: pxToRemSmallTablet(-5);
        }
      }
      .pixel-picks__dialog__message,
      .pixel-picks__dialog__loading,
      .pixel-picks__dialog__login {
        font-size: pxToRemSmallTablet(18);
        max-height: 100%; // 32px + 32px padding + 40px  v-overlay__content max-height
        height: pxToRemSmallTablet(236);
      }

      .pixel-picks__dialog__message {
        &--vote-success {
          max-width: pxToRemSmallTablet(380);
        }
        &--round-ended {
          max-width: pxToRemSmallTablet(490);
        }
        &--already-voted {
          max-width: pxToRemSmallTablet(360);
        }
        &--not-eligible {
          max-width: pxToRemSmallTablet(340);
        }
      }

      .pixel-picks__dialog__login {
        height: auto;
        &__title {
          font-size: pxToRemSmallTablet(36);
          margin-top: pxToRemSmallTablet(8.2, $round: false);
          margin-bottom: pxToRemSmallTablet(6);
        }

        .pixel-picks__line-star {
          padding-left: pxToRemSmallTablet(31);
          padding-right: pxToRemSmallTablet(31);
          margin-bottom: pxToRemSmallTablet(10);
        }

        &__img {
          height: pxToRemSmallTablet(291);
          margin-top: pxToRemSmallTablet(12, $round: false);
          margin-bottom: pxToRemSmallTablet(25);
        }
        .pixel-picks__button {
          font-size: pxToRemSmallTablet(30);
          min-height: pxToRemSmallTablet(60);
          min-width: pxToRemSmallTablet(204);
          padding: pxToRemSmallTablet(10);
          border-radius: pxToRemSmallTablet(50);
          bottom: pxToRemSmallTablet(-8);
        }
      }
    }
  }

  @media #{$mobile} {
    .pixel-picks__dialog {
      .pixel-picks__line-star {
        font-size: 36px;
        column-gap: 4px;
        .line {
          height: 0.12em;
          border-radius: 5px;
        }
        .star {
          font-size: 20px;
          min-width: 20px;
        }
      }

      .v-overlay__content {
        max-height: calc(100% - 40px);
        max-width: min(95%, 340px) !important;
        width: calc(100% - 20px) !important;
      }
      .dialog-frame {
        .text-dialog {
          padding: 2px 5px !important;
          > svg {
            margin-top: 5px !important;
            margin-right: 5px !important;
          }
          .styled-scrollbar {
            padding-left: 5px !important;
            padding-right: 5px !important;
          }
        }
      }

      .pixel-picks__dialog__details {
        font-size: 18px;
        padding-top: 10px;
        padding-bottom: 10px;

        p {
          margin-bottom: 12px;
        }
        ul {
          margin-bottom: 12px;
        }

        &__top {
          max-width: 280px;
          margin-bottom: 6px;
          p {
            margin-bottom: 0;
          }
        }

        &__middle {
          max-width: 276px;
          margin-top: 5px;
          p {
            &:last-child {
              margin-bottom: 13px;
            }
          }
        }

        &__bottom {
          max-width: 456px;
          margin-top: 4px;
          margin-bottom: 3px;
        }

        .crown-icon {
          width: 22px;
          height: 24px;
          margin-bottom: -5px;
        }
      }
      .pixel-picks__dialog__message,
      .pixel-picks__dialog__loading,
      .pixel-picks__dialog__login {
        font-size: 18px;
        max-height: calc(100vh - 104px); // 32px + 32px padding + 40px  v-overlay__content max-height
        height: 236px;
      }

      .pixel-picks__dialog__message {
        &--vote-success {
          max-width: 380px;
        }
        &--round-ended {
          max-width: 490px;
        }
        &--already-voted {
          max-width: 360px;
        }
        &--not-eligible {
          max-width: 340px;
        }
      }

      .pixel-picks__dialog__login {
        height: auto;
        padding-top: 10px;
        padding-bottom: 10px;
        align-content: flex-start;
        &__title {
          font-size: 36px;
          margin-top: 0;
          margin-bottom: 0;
        }

        .pixel-picks__line-star {
          padding-left: 31px;
          padding-right: 31px;
          margin-bottom: 4px;
        }

        &__text1 {
          font-size: 16px;
        }

        &__text2 {
          font-size: 14px;
        }

        &__img {
          height: 180px;
          margin-top: 0;
          background-position: top center;
          z-index: 0;
        }
        .pixel-picks__button {
          font-size: 30px;
          min-height: 60px;
          min-width: 204px;
          padding: 10px;
          bottom: 0;
          z-index: 1;
        }
      }
    }
  }

  @media (max-width: 375px) {
    .pixel-picks__dialog {
      .pixel-picks__line-star {
        font-size: pxToRemMobile360(36);
        column-gap: pxToRemMobile360(4);

        .line {
          height: 0.12em;
          border-radius: pxToRemMobile360(5);
        }
        .star {
          font-size: pxToRemMobile360(20);
          min-width: pxToRemMobile360(20);
        }
      }

      .v-overlay__content {
        max-height: calc(100% - 40px);
        max-width: min(98%, pxToRemMobile360(340px)) !important;
        width: calc(100% - 20px) !important;
      }
      .dialog-frame {
        .text-dialog {
          padding: pxToRemMobile360(2) pxToRemMobile360(5) !important;
          > svg {
            margin-top: 5px !important;
            margin-right: 5px !important;
          }
          .styled-scrollbar {
            padding-left: pxToRemMobile360(5) !important;
            padding-right: pxToRemMobile360(5) !important;
          }
        }
      }

      .pixel-picks__dialog__details {
        font-size: pxToRemMobile360(18);
        padding-top: pxToRemMobile360(10);
        padding-bottom: pxToRemMobile360(10);

        p {
          margin-bottom: pxToRemMobile360(12, $round: false);
        }
        ul {
          margin-bottom: pxToRemMobile360(12);
        }

        &__top {
          max-width: pxToRemMobile360(280);
          margin-bottom: pxToRemMobile360(6);
          p {
            margin-bottom: 0;
          }
        }

        &__middle {
          max-width: pxToRemMobile360(276);
          margin-top: pxToRemMobile360(5);
          p {
            &:last-child {
              margin-bottom: pxToRem(13);
            }
          }
        }

        &__bottom {
          max-width: pxToRemMobile360(456);
          margin-top: pxToRemMobile360(4);
          margin-bottom: pxToRemMobile360(3);
        }

        .crown-icon {
          width: pxToRemMobile360(22);
          height: pxToRemMobile360(24);
          margin-bottom: pxToRemMobile360(-5);
        }
      }
      .pixel-picks__dialog__message,
      .pixel-picks__dialog__loading,
      .pixel-picks__dialog__login {
        font-size: pxToRemMobile360(18);
        max-height: calc(100vh - 104px); // 32px + 32px padding + 40px  v-overlay__content max-height
        height: pxToRemMobile360(236);
      }

      .pixel-picks__dialog__message {
        &--vote-success {
          max-width: pxToRemMobile360(380);
        }
        &--round-ended {
          max-width: pxToRemMobile360(490);
        }
        &--already-voted {
          max-width: pxToRemMobile360(360);
        }
        &--not-eligible {
          max-width: pxToRemMobile360(340);
        }
      }

      .pixel-picks__dialog__login {
        height: auto;
        padding-top: pxToRemMobile360(10);
        padding-bottom: pxToRemMobile360(10);
        align-content: flex-start;
        &__title {
          font-size: pxToRemMobile360(36);
          margin-top: pxToRemMobile360(0);
          margin-bottom: pxToRemMobile360(0);
        }

        .pixel-picks__line-star {
          padding-left: pxToRemMobile360(31);
          padding-right: pxToRemMobile360(31);
          margin-bottom: pxToRemMobile360(4);
        }

        &__text1 {
          font-size: pxToRemMobile360(16);
        }

        &__text2 {
          font-size: pxToRemMobile360(14);
        }

        &__img {
          height: pxToRemMobile360(180);
          margin-top: pxToRemMobile360(0);
          background-position: top center;
          z-index: 0;
        }
        .pixel-picks__button {
          font-size: pxToRemMobile360(30);
          min-height: pxToRemMobile360(60);
          min-width: pxToRemMobile360(204);
          padding: pxToRemMobile360(10);
          bottom: pxToRemMobile360(0);
          z-index: 1;
        }
      }
    }
  }
</style>
